import React from 'react';
import {connect} from 'react-redux';
import BaseMultConsumption from 'components/BaseMultConsumption';
import {getKTPConsumptionByApp} from 'actions/consumption';
import {getChartSeries} from 'utils/consumptionTool';


const SKULIST = [
    {
        name:'Indonesia ID card',
        contract_type:17,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'Quality Detection',
                dataIndex: 'quality_detect',
                key: 'quality_detect',
                sorter:true
            },{
                title: 'Recognition',
                dataIndex: 'cert_recognize',
                key: 'cert_recognize',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Quality Detection: <span style={{color:'#6D74F4'}}>{total.quality_detect||0}</span> ,Recognition: <span style={{color:'#6D74F4'}}>{total.cert_recognize || 0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'quality_detect',
                name:'Quality Detection',
                color:'#8A90FF'
            },
            {
                key:'cert_recognize',
                name:'Recognition',
                color:'#99CCFF'
            }
        ])
    },
    {
        name:'Indonesia ID card Advanced',
        contract_type:50,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'Recognition',
                dataIndex: 'ocr_image',
                key: 'ocr_image',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Recognition: <span style={{color:'#6D74F4'}}>{total.ocr_image || 0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'ocr_image',
                name:'Recognition',
                color:'#8A90FF'
            }
        ])
    },

];
class KTPConsumption extends React.Component {

    render() {
        return (
            <BaseMultConsumption
                skuList={SKULIST}
                getInfoPromise={getKTPConsumptionByApp}
            />
        );

    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(KTPConsumption);



// WEBPACK FOOTER //
// ./src/pages/KTPConsumption/index.js